import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { nameMaxLength } from '../../Constant.js'
import axios from 'axios'
import CheckPermission from '../../common/Permissions/CheckPermission.js'

class CategoryAdd extends React.Component {
  state = {
    category_type: 'CRUISE',
    cruise_cat_en: '',
    cruise_cat_ar: '',
    category_id: '',
    upto_s: '',
    isData: false,
    Edit: false,

    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files?.[0] })
    this.setState({ Edit: false })
    this.setState({ img: URL.createObjectURL(e.target.files?.[0]) })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {
    var that = this
    var data = new FormData()
    that.setState({ isSaving: true })

    if (
      that.state.cruise_cat_en === undefined ||
      that.state.cruise_cat_en === null ||
      that.state.cruise_cat_en === '' ||
      that.state.cruise_cat_ar === undefined ||
      that.state.cruise_cat_ar === null ||
      that.state.cruise_cat_ar === ''
    ) {
      document.getElementById('category')?.focus()
      that.setState({ isSaving: false })
      return false
    }
    // if (this.props.category_id) {
    //   data.append("main_category_id", that.props.category_id);
    // }
    data.append('cruise_cat_en', that.state.cruise_cat_en)
    data.append('cruise_cat_ar', that.state.cruise_cat_ar)
    data.append('category_type', that.state.category_type)
    data.append('order', that.state.order)
    data.append('upto_s', that.state.upto_s)

    data.append('meta_title_en', this.state.meta_title_en)
    data.append('meta_title_ar', this.state.meta_title_ar)
    data.append('meta_desc_en', this.state.meta_desc_en)
    data.append('meta_desc_ar', this.state.meta_desc_ar)
    data.append('meta_keywords_en', this.state.meta_keywords_en)
    data.append('meta_keywords_ar', this.state.meta_keywords_ar)
    data.append('h1_ar', this.state.h1_ar)
    data.append('h1_en', this.state.h1_en)
    data.append('h2_ar', this.state.h2_ar)
    data.append('h2_en', this.state.h2_en)

    this.setState({ isData: true })

    if (this.props.match.params.category_id) {
      data.append('cruise_master_id', this.props.match.params.category_id)
      if (this.state.cruise_cat_img?.name) {
        data.append('cruise_cat_img', this.state.cruise_cat_img)
      }
      axios
        .put(Constant.getAPI() + '/admin/update-cruise-master', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          this.setState({ isData: false })
          Swal.fire({
            title: 'Category Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then(() => {
            window.location.href = '#/category'
            window.location.reload()
          })
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      data.append('cruise_cat_img', this.state.cruise_cat_img)
      axios
        .post(Constant.getAPI() + '/admin/create-cruise-master', data, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'Category Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            }).then(() => {
              window.location.href = '#/category'
              window.location.reload()
            })
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  componentDidMount() {
    if (this.props.match.params.category_id) {
      this.getCategoryMaster()
    }
  }

  getCategoryMaster = async () => {
    await axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const matchItem = res.data.data.filter((itm) => itm.id === this.props.match.params.category_id)

          if (matchItem?.length) {
            const itm = matchItem[0]
            this.setState({
              ...itm,
            })
            this.setState({ Edit: true })
          }
        }
      })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.props.match.params.category_id ? 'Edit' : 'Add'} Category</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/category">Category List</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.category_id ? 'Edit' : 'Add'} Category
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Category Name: English</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="cruise_cat_en"
                                id="category"
                                placeholder="Category Name: English"
                                onChange={this.handleChange}
                                maxLength={nameMaxLength}
                                value={this.state.cruise_cat_en}
                              />
                            </div>
                            <div className="col-sm-12 text-right">
                              {this.state.cruise_cat_en
                                ? this.state.cruise_cat_en.length + ' / ' + nameMaxLength
                                : 0 + ' / ' + nameMaxLength}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Category Name: Arabic</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="cruise_cat_ar"
                                id="categoryAr"
                                placeholder="Category Name: Arabic"
                                onChange={this.handleChange}
                                value={this.state.cruise_cat_ar}
                              />
                            </div>
                            <div className="col-sm-12 text-right">
                              {this.state.cruise_cat_ar
                                ? this.state.cruise_cat_ar.length + ' / ' + nameMaxLength
                                : 0 + ' / ' + nameMaxLength}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Upto</label>
                            <div className="col-sm-9">
                              <input
                                type="text"
                                className="form-control"
                                name="upto_s"
                                id="upto_s"
                                placeholder="7,10,12"
                                onChange={this.handleChange}
                                value={this.state.upto_s}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Category Type</label>
                            <div className="col-sm-9">
                              <select
                                name="category_type"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.category_type}
                              >
                                <option value="CRUISE">CRUISE</option>
                                <option value="EVENT">EVENT</option>
                                <option value="ACTIVITY">ACTIVITY</option>
                                <option value="SHOP">SHOP</option>
                                <option value="CATERING">CATERING</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Order</label>
                            <div className="col-sm-9">
                              <input
                                type="number"
                                className="form-control"
                                name="order"
                                id="order"
                                placeholder="Enter number"
                                onChange={this.handleChange}
                                value={this.state.order}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-sm-3"> Image</div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <div>
                                  <input
                                    type="file"
                                    id="img"
                                    name="cruise_cat_img"
                                    accept="image/*"
                                    className="w-100"
                                    onChange={this.handleChangeImage}
                                  />
                                </div>
                              </div>
                              {this.state.Edit ? (
                                <img
                                  width="250px"
                                  height="200px"
                                  src={Constant.getImage() + this.state.cruise_cat_img}
                                  alt="img"
                                />
                              ) : (
                                <img
                                  width="250px"
                                  height="200px"
                                  src={this.state.img}
                                  alt="img"
                                />
                              )}
                            </div>
                          </div>
                        </div>
                        <CheckPermission permission={'manage-meta-tags'}>
                          <div
                            className="col-md-12"
                            style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                          ></div>
                          <h5
                            style={{
                              marginBottom: 23,
                              marginLeft: 13,
                              fontWeight: 'bold',
                              fontSize: 18,
                              width: '100%',
                            }}
                          >
                            Meta Settings
                          </h5>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Meta Title: English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_title_en"
                                  id="meta_title_en"
                                  placeholder=""
                                  onChange={this.handleChange}
                                  value={this.state.meta_title_en}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_title_ar"
                                  id="meta_title_ar"
                                  placeholder=" "
                                  onChange={this.handleChange}
                                  value={this.state.meta_title_ar}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Meta Keywords: English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_keywords_en"
                                  id="meta_keywords_en"
                                  placeholder=""
                                  onChange={this.handleChange}
                                  value={this.state.meta_keywords_en}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Meta Keywords: Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_keywords_ar"
                                  id="meta_keywords_ar"
                                  placeholder=""
                                  onChange={this.handleChange}
                                  value={this.state.meta_keywords_ar}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Meta Description: English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_desc_en"
                                  id="meta_desc_en"
                                  value={this.state.meta_desc_en}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="meta_desc_ar"
                                  id="meta_desc_ar"
                                  value={this.state.meta_desc_ar}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">H1: English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="h1_en"
                                  id="h1_en"
                                  placeholder="H1: English"
                                  onChange={this.handleChange}
                                  value={this.state.h1_en}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">H1: Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="h1_ar"
                                  id="h1_ar"
                                  placeholder="H1: Arabic"
                                  onChange={this.handleChange}
                                  value={this.state.h1_ar}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">H2: English</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="h2_en"
                                  id="h2_en"
                                  placeholder="H2: English"
                                  onChange={this.handleChange}
                                  value={this.state.h2_en}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">H2: Arabic</label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="h2_ar"
                                  id="h2_ar"
                                  placeholder="H2: Arabic"
                                  onChange={this.handleChange}
                                  value={this.state.h2_ar}
                                />
                              </div>
                            </div>
                          </div>
                        </CheckPermission>
                      </div>
                      <div className="card-footer">
                        <div className="row">
                          <div className="text-right col-6 offset-6">
                            <Link
                              to="/category"
                              className="btn btn-outline-secondary m-2 "
                            >
                              <i className="icofont icofont-rounded-double-left"></i>Back
                            </Link>
                            {this.state.isData ? (
                              <button
                                className="btn btn-grd-disabled mr-2"
                                disabled
                              >
                                Saving...!
                              </button>
                            ) : (
                              <button
                                onClick={this.onSaveData}
                                className="btn hor-grd btn-grd-inverse offset-1"
                              >
                                <i className="ti-save"></i>Save
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CategoryAdd
